export const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL;
export const APP_ID = process.env.REACT_APP_AUTH_APP_ID;
export const IS_APP_SANDBOX = process.env.REACT_APP_AUTH_APP_IS_SANDBOX == 'true';
export const HAT_DOMAIN = process.env.REACT_APP_AUTH_DOMAIN;

interface IAppConfig {
  version: string;
  acceptedLanguages: string[];
  defaultLanguage: string;
  matomoUrl: string;
  matomoSiteId: number;
  links: {
    bestPractices: string;
    termsOfService: string;
    privacyPolicy: string;
    hatdexRating: string;
  };
}

const externalLinks = {
  bestPractices: 'https://docs.dataswift.io/guides/security-requirement-best-practice#password-policy',
  termsOfService: 'https://www.dataswift.io/legal/pda-owner-agreement-en',
  privacyPolicy: 'https://www.dataswift.io/legal/privacy-policy-en',
  hatdexRating: 'https://docs.dataswift.io/knowledge-base/application-review/rating-assurance-and-certification',
};

export const config: IAppConfig = {
  version: '1.9.0',
  acceptedLanguages: ['en', 'pl', 'pt'],
  defaultLanguage: 'en',
  matomoUrl: 'https://dataswift.matomo.cloud/',
  matomoSiteId: 2,
  links: {
    bestPractices: externalLinks.bestPractices,
    termsOfService: externalLinks.termsOfService,
    privacyPolicy: externalLinks.privacyPolicy,
    hatdexRating: externalLinks.hatdexRating,
  },
};
